function mapDeliveryEstimation(data, locale) {
  const response = data?.deliveryEstimation?.response;
  if (!response) return null;
  const deliveryEstimation = {
    shippingMethodDescription: response.shippingMethodDescription?.find(
      (description) => description.locale === locale || description.locale === locale.substr(0, 2)
    )?.value ?? ""
  };
  if ("deliveryRanges" in response) {
    deliveryEstimation.deliveryRanges = {
      min: response.deliveryRanges.min,
      max: response.deliveryRanges.max,
      minWithPrescription: response.deliveryRanges.minWithPrescription,
      maxWithPrescription: response.deliveryRanges.maxWithPrescription
    };
  }
  if ("deliveryDate" in response) {
    deliveryEstimation.deliveryDate = response.deliveryDate ? new Date(response.deliveryDate) : void 0;
  }
  return deliveryEstimation;
}
export {
  mapDeliveryEstimation
};
//# sourceMappingURL=delivery-estimation.js.map
